import { render, staticRenderFns } from "./ModalDetalhesEvento.vue?vue&type=template&id=3d70508d&"
import script from "./ModalDetalhesEvento.vue?vue&type=script&lang=js&"
export * from "./ModalDetalhesEvento.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetalhesEvento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports